module.exports = __webpack_public_path__ + "static/media/submenu-servicos.0cc5b897.svg";